import imagesLoaded from 'imagesloaded';

export default function() {
  const element = document.querySelector('.c-sectionHeading')
  if(element) {
    imagesLoaded( '.c-sectionHeading__image', { background: true }, function(e) {
      element.classList.add('is-loaded');
    });
  }
}